module.exports = __webpack_public_path__ + "static/media/LogoDark.c147d71a.svg";